import React from 'react';
import { Typography, Box } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

interface HelpBubbleContentProps {
  pageKey?: string;
  defaultText?: string;
}

export default function HelpBubbleContent({ pageKey, defaultText }: HelpBubbleContentProps) {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === 'en' || i18n.language.startsWith('en-');

  return (
    <Box>
      {!isEnglish && (
        <Typography variant="body2" color="error" sx={{ mb: 2, fontWeight: 'bold' }}>
          <Trans i18nKey="common.englishOnlyWarning" />
        </Typography>
      )}

      {!pageKey && !defaultText ? (
        <Typography>No help available for this page.</Typography>
      ) : (
        <Typography variant="body1" component="div">
          <Trans i18nKey={`help.${pageKey}`} defaults={defaultText} />
        </Typography>
      )}
    </Box>
  );
}
